/**
 * Do not edit directly, this file was auto-generated.
 */

import { css } from 'styled-components';
export const cssVariables = css`
  --mlb-2-1-0-color-white: #ffffff;
  --mlb-2-1-0-color-black: #000000;
  --mlb-2-1-0-color-neutral-neutral100: #f4f5f6;
  --mlb-2-1-0-color-neutral-neutral200: #e8eaed;
  --mlb-2-1-0-color-neutral-neutral300: #dbdfe3;
  --mlb-2-1-0-color-neutral-neutral400: #c3c8cf;
  --mlb-2-1-0-color-neutral-neutral500: #acb3bc;
  --mlb-2-1-0-color-neutral-neutral600: #959da8;
  --mlb-2-1-0-color-neutral-neutral700: #7f8994;
  --mlb-2-1-0-color-neutral-neutral800: #6a7480;
  --mlb-2-1-0-color-neutral-neutral900: #57606c;
  --mlb-2-1-0-color-neutral-neutral1000: #444d58;
  --mlb-2-1-0-color-neutral-neutral1100: #333b44;
  --mlb-2-1-0-color-neutral-neutral1200: #232931;
  --mlb-2-1-0-color-neutral-neutral1300: #14191f;
  --mlb-2-1-0-color-neutral-neutral1400: #070a0d;
  --mlb-2-1-0-color-yellow-yellow100: #f7e0c8; /* Shade color with 92% of lightness */
  --mlb-2-1-0-color-yellow-yellow200: #edc394; /* Shade color with 84.2% of lightness */
  --mlb-2-1-0-color-yellow-yellow300: #e0a561; /* Shade color with 76.4% of lightness */
  --mlb-2-1-0-color-yellow-yellow400: #d08929; /* Shade color with 68.7% of lightness */
  --mlb-2-1-0-color-yellow-yellow500: #bd6d00; /* Shade color with 60.9% of lightness */
  --mlb-2-1-0-color-yellow-yellow600: #a65400; /* Shade color with 53.1% of lightness */
  --mlb-2-1-0-color-yellow-yellow700: #8c3c00; /* Shade color with 45.3% of lightness */
  --mlb-2-1-0-color-yellow-yellow800: #712800; /* Shade color with 37.6% of lightness */
  --mlb-2-1-0-color-yellow-yellow900: #541700; /* Shade color with 29.8% of lightness */
  --mlb-2-1-0-color-yellow-yellow1000: #370900; /* Shade color with 22% of lightness */
  --mlb-2-1-0-color-green-green100: #d4edd3; /* Shade color with 92% of lightness */
  --mlb-2-1-0-color-green-green200: #acdaa9; /* Shade color with 84.2% of lightness */
  --mlb-2-1-0-color-green-green300: #84c681; /* Shade color with 76.4% of lightness */
  --mlb-2-1-0-color-green-green400: #5eb15c; /* Shade color with 68.7% of lightness */
  --mlb-2-1-0-color-green-green500: #399a39; /* Shade color with 60.9% of lightness */
  --mlb-2-1-0-color-green-green600: #098314; /* Shade color with 53.1% of lightness */
  --mlb-2-1-0-color-green-green700: #006c00; /* Shade color with 45.3% of lightness */
  --mlb-2-1-0-color-green-green800: #005400; /* Shade color with 37.6% of lightness */
  --mlb-2-1-0-color-green-green900: #003c00; /* Shade color with 29.8% of lightness */
  --mlb-2-1-0-color-green-green1000: #002500; /* Shade color with 22% of lightness */
  --mlb-2-1-0-color-red-red100: #ffd8d4; /* Shade color with 92% of lightness */
  --mlb-2-1-0-color-red-red200: #ffb3ad; /* Shade color with 84.2% of lightness */
  --mlb-2-1-0-color-red-red300: #fd8d87; /* Shade color with 76.4% of lightness */
  --mlb-2-1-0-color-red-red400: #f16966; /* Shade color with 68.7% of lightness */
  --mlb-2-1-0-color-red-red500: #de4447; /* Shade color with 60.9% of lightness */
  --mlb-2-1-0-color-red-red600: #c61b2b; /* Shade color with 53.1% of lightness */
  --mlb-2-1-0-color-red-red700: #aa0013; /* Shade color with 45.3% of lightness */
  --mlb-2-1-0-color-red-red800: #8a0000; /* Shade color with 37.6% of lightness */
  --mlb-2-1-0-color-red-red900: #680000; /* Shade color with 29.8% of lightness */
  --mlb-2-1-0-color-red-red1000: #450000; /* Shade color with 22% of lightness */
  --mlb-2-1-0-color-blue-blue100: #d0e6ff; /* Shade color with 92% of lightness */
  --mlb-2-1-0-color-blue-blue200: #a4cdff; /* Shade color with 84.2% of lightness */
  --mlb-2-1-0-color-blue-blue300: #7ab2ff; /* Shade color with 76.4% of lightness */
  --mlb-2-1-0-color-blue-blue400: #5298ff; /* Shade color with 68.7% of lightness */
  --mlb-2-1-0-color-blue-blue500: #2c7df8; /* Shade color with 60.9% of lightness */
  --mlb-2-1-0-color-blue-blue600: #0062e3; /* Shade color with 53.1% of lightness */
  --mlb-2-1-0-color-blue-blue700: #0048c7; /* Shade color with 45.3% of lightness */
  --mlb-2-1-0-color-blue-blue800: #0031a6; /* Shade color with 37.6% of lightness */
  --mlb-2-1-0-color-blue-blue900: #001d80; /* Shade color with 29.8% of lightness */
  --mlb-2-1-0-color-blue-blue1000: #000c57; /* Shade color with 22% of lightness */
  --mlb-2-1-0-color-purple-purple100: #e7e0fa; /* Shade color with 92% of lightness */
  --mlb-2-1-0-color-purple-purple200: #d0c2f3; /* Shade color with 84.2% of lightness */
  --mlb-2-1-0-color-purple-purple300: #b9a5e9; /* Shade color with 76.4% of lightness */
  --mlb-2-1-0-color-purple-purple400: #a38adb; /* Shade color with 68.7% of lightness */
  --mlb-2-1-0-color-purple-purple500: #8d6fc9; /* Shade color with 60.9% of lightness */
  --mlb-2-1-0-color-purple-purple600: #7756b3; /* Shade color with 53.1% of lightness */
  --mlb-2-1-0-color-purple-purple700: #613f99; /* Shade color with 45.3% of lightness */
  --mlb-2-1-0-color-purple-purple800: #4b2b7d; /* Shade color with 37.6% of lightness */
  --mlb-2-1-0-color-purple-purple900: #361a5e; /* Shade color with 29.8% of lightness */
  --mlb-2-1-0-color-purple-purple1000: #210b3e; /* Shade color with 22% of lightness */
  --mlb-2-1-0-radius-radius0: calc(var(--mlb-2-1-0-radius-radius-base, 8px) * 0);
  --mlb-2-1-0-radius-radius25: calc(var(--mlb-2-1-0-radius-radius-base, 8px) / 4);
  --mlb-2-1-0-radius-radius50: calc(var(--mlb-2-1-0-radius-radius-base, 8px) / 2);
  --mlb-2-1-0-radius-radius100: calc(var(--mlb-2-1-0-radius-radius-base, 8px) * 1);
  --mlb-2-1-0-radius-radius150: calc(var(--mlb-2-1-0-radius-radius-base, 8px) * 1.5);
  --mlb-2-1-0-radius-radius300: calc(var(--mlb-2-1-0-radius-radius-base, 8px) * 3);
  --mlb-2-1-0-radius-radius-max: calc(var(--mlb-2-1-0-radius-radius-base, 8px) * 1000);
  --mlb-2-1-0-radius-radius-base: 8px;
  --mlb-2-1-0-space-space0: calc(var(--mlb-2-1-0-space-base, 8px) * 0);
  --mlb-2-1-0-space-space25: calc(var(--mlb-2-1-0-space-base, 8px) * 0.25);
  --mlb-2-1-0-space-space50: calc(var(--mlb-2-1-0-space-base, 8px) * 0.5);
  --mlb-2-1-0-space-space75: calc(var(--mlb-2-1-0-space-base, 8px) * 0.75);
  --mlb-2-1-0-space-space100: var(--mlb-2-1-0-space-base, 8px);
  --mlb-2-1-0-space-space150: calc(var(--mlb-2-1-0-space-base, 8px) * 1.5);
  --mlb-2-1-0-space-space200: calc(var(--mlb-2-1-0-space-base, 8px) * 2);
  --mlb-2-1-0-space-space300: calc(var(--mlb-2-1-0-space-base, 8px) * 3);
  --mlb-2-1-0-space-space400: calc(var(--mlb-2-1-0-space-base, 8px) * 4);
  --mlb-2-1-0-space-space500: calc(var(--mlb-2-1-0-space-base, 8px) * 5);
  --mlb-2-1-0-space-space600: calc(var(--mlb-2-1-0-space-base, 8px) * 6);
  --mlb-2-1-0-space-space700: calc(var(--mlb-2-1-0-space-base, 8px) * 7);
  --mlb-2-1-0-space-space800: calc(var(--mlb-2-1-0-space-base, 8px) * 8);
  --mlb-2-1-0-space-space900: calc(var(--mlb-2-1-0-space-base, 8px) * 9);
  --mlb-2-1-0-space-space1000: calc(var(--mlb-2-1-0-space-base, 8px) * 10);
  --mlb-2-1-0-space-base: 8px;
  --mlb-2-1-0-opacity-opacity5: 0.05;
  --mlb-2-1-0-opacity-opacity10: 0.1;
  --mlb-2-1-0-opacity-opacity20: 0.2;
  --mlb-2-1-0-opacity-opacity40: 0.4;
  --mlb-2-1-0-opacity-opacity70: 0.7;
  --mlb-2-1-0-blur-overlay: 16;
  --mlb-2-1-0-font-size-100: 0.625rem;
  --mlb-2-1-0-font-size-200: 0.75rem;
  --mlb-2-1-0-font-size-300: 0.875rem;
  --mlb-2-1-0-font-size-400: 1rem;
  --mlb-2-1-0-font-size-500: 1.1875rem;
  --mlb-2-1-0-font-size-600: 1.4375rem;
  --mlb-2-1-0-font-size-700: 1.75rem;
  --mlb-2-1-0-font-size-800: 2.0625rem;
  --mlb-2-1-0-font-size-900: 2.5rem;
  --mlb-2-1-0-font-size-1000: 3rem;
  --mlb-2-1-0-font-size-1100: 3.5625rem;
  --mlb-2-1-0-font-size-1200: 4.3125rem;
  --mlb-2-1-0-font-weight-400: 400;
  --mlb-2-1-0-font-weight-500: 500;
  --mlb-2-1-0-font-weight-600: 600;
  --mlb-2-1-0-font-weight-700: 700;
  --mlb-2-1-0-font-weight-800: 800;
  --mlb-2-1-0-line-height-reset: 1;
  --mlb-2-1-0-line-height-headline: 1.2;
  --mlb-2-1-0-line-height-paragraph: 1.5;
  --mlb-2-1-0-letter-spacing-default: 0em;
  --mlb-2-1-0-letter-spacing-exta-small: 0.02em;
  --mlb-2-1-0-letter-spacing-small: 0.04em;
  --mlb-2-1-0-letter-spacing-medium: 0.08em;
  --mlb-2-1-0-text-case-default: Original;
  --mlb-2-1-0-text-case-uppercase: Uppercase;
  --mlb-2-1-0-text-case-capitalize: Capitalize;
  --mlb-2-1-0-paragraph-spacing-none: 0px;
  --mlb-2-1-0-paragraph-spacing-default: 32px;
  --mlb-2-1-0-paragraph-indent-none: 0px;
  --mlb-2-1-0-text-decoration-none: none;
  --mlb-2-1-0-font-family-proximanova: 'Proxima Nova';
`;
export const theme = {
  'color/white': 'var(--mlb-2-1-0-color-white)',
  'color/black': 'var(--mlb-2-1-0-color-black)',
  'color/neutral/neutral100': 'var(--mlb-2-1-0-color-neutral-neutral100)',
  'color/neutral/neutral200': 'var(--mlb-2-1-0-color-neutral-neutral200)',
  'color/neutral/neutral300': 'var(--mlb-2-1-0-color-neutral-neutral300)',
  'color/neutral/neutral400': 'var(--mlb-2-1-0-color-neutral-neutral400)',
  'color/neutral/neutral500': 'var(--mlb-2-1-0-color-neutral-neutral500)',
  'color/neutral/neutral600': 'var(--mlb-2-1-0-color-neutral-neutral600)',
  'color/neutral/neutral700': 'var(--mlb-2-1-0-color-neutral-neutral700)',
  'color/neutral/neutral800': 'var(--mlb-2-1-0-color-neutral-neutral800)',
  'color/neutral/neutral900': 'var(--mlb-2-1-0-color-neutral-neutral900)',
  'color/neutral/neutral1000': 'var(--mlb-2-1-0-color-neutral-neutral1000)',
  'color/neutral/neutral1100': 'var(--mlb-2-1-0-color-neutral-neutral1100)',
  'color/neutral/neutral1200': 'var(--mlb-2-1-0-color-neutral-neutral1200)',
  'color/neutral/neutral1300': 'var(--mlb-2-1-0-color-neutral-neutral1300)',
  'color/neutral/neutral1400': 'var(--mlb-2-1-0-color-neutral-neutral1400)',
  'color/yellow/yellow100': 'var(--mlb-2-1-0-color-yellow-yellow100)',
  'color/yellow/yellow200': 'var(--mlb-2-1-0-color-yellow-yellow200)',
  'color/yellow/yellow300': 'var(--mlb-2-1-0-color-yellow-yellow300)',
  'color/yellow/yellow400': 'var(--mlb-2-1-0-color-yellow-yellow400)',
  'color/yellow/yellow500': 'var(--mlb-2-1-0-color-yellow-yellow500)',
  'color/yellow/yellow600': 'var(--mlb-2-1-0-color-yellow-yellow600)',
  'color/yellow/yellow700': 'var(--mlb-2-1-0-color-yellow-yellow700)',
  'color/yellow/yellow800': 'var(--mlb-2-1-0-color-yellow-yellow800)',
  'color/yellow/yellow900': 'var(--mlb-2-1-0-color-yellow-yellow900)',
  'color/yellow/yellow1000': 'var(--mlb-2-1-0-color-yellow-yellow1000)',
  'color/green/green100': 'var(--mlb-2-1-0-color-green-green100)',
  'color/green/green200': 'var(--mlb-2-1-0-color-green-green200)',
  'color/green/green300': 'var(--mlb-2-1-0-color-green-green300)',
  'color/green/green400': 'var(--mlb-2-1-0-color-green-green400)',
  'color/green/green500': 'var(--mlb-2-1-0-color-green-green500)',
  'color/green/green600': 'var(--mlb-2-1-0-color-green-green600)',
  'color/green/green700': 'var(--mlb-2-1-0-color-green-green700)',
  'color/green/green800': 'var(--mlb-2-1-0-color-green-green800)',
  'color/green/green900': 'var(--mlb-2-1-0-color-green-green900)',
  'color/green/green1000': 'var(--mlb-2-1-0-color-green-green1000)',
  'color/red/red100': 'var(--mlb-2-1-0-color-red-red100)',
  'color/red/red200': 'var(--mlb-2-1-0-color-red-red200)',
  'color/red/red300': 'var(--mlb-2-1-0-color-red-red300)',
  'color/red/red400': 'var(--mlb-2-1-0-color-red-red400)',
  'color/red/red500': 'var(--mlb-2-1-0-color-red-red500)',
  'color/red/red600': 'var(--mlb-2-1-0-color-red-red600)',
  'color/red/red700': 'var(--mlb-2-1-0-color-red-red700)',
  'color/red/red800': 'var(--mlb-2-1-0-color-red-red800)',
  'color/red/red900': 'var(--mlb-2-1-0-color-red-red900)',
  'color/red/red1000': 'var(--mlb-2-1-0-color-red-red1000)',
  'color/blue/blue100': 'var(--mlb-2-1-0-color-blue-blue100)',
  'color/blue/blue200': 'var(--mlb-2-1-0-color-blue-blue200)',
  'color/blue/blue300': 'var(--mlb-2-1-0-color-blue-blue300)',
  'color/blue/blue400': 'var(--mlb-2-1-0-color-blue-blue400)',
  'color/blue/blue500': 'var(--mlb-2-1-0-color-blue-blue500)',
  'color/blue/blue600': 'var(--mlb-2-1-0-color-blue-blue600)',
  'color/blue/blue700': 'var(--mlb-2-1-0-color-blue-blue700)',
  'color/blue/blue800': 'var(--mlb-2-1-0-color-blue-blue800)',
  'color/blue/blue900': 'var(--mlb-2-1-0-color-blue-blue900)',
  'color/blue/blue1000': 'var(--mlb-2-1-0-color-blue-blue1000)',
  'color/purple/purple100': 'var(--mlb-2-1-0-color-purple-purple100)',
  'color/purple/purple200': 'var(--mlb-2-1-0-color-purple-purple200)',
  'color/purple/purple300': 'var(--mlb-2-1-0-color-purple-purple300)',
  'color/purple/purple400': 'var(--mlb-2-1-0-color-purple-purple400)',
  'color/purple/purple500': 'var(--mlb-2-1-0-color-purple-purple500)',
  'color/purple/purple600': 'var(--mlb-2-1-0-color-purple-purple600)',
  'color/purple/purple700': 'var(--mlb-2-1-0-color-purple-purple700)',
  'color/purple/purple800': 'var(--mlb-2-1-0-color-purple-purple800)',
  'color/purple/purple900': 'var(--mlb-2-1-0-color-purple-purple900)',
  'color/purple/purple1000': 'var(--mlb-2-1-0-color-purple-purple1000)',
  'radius/radius0': 'var(--mlb-2-1-0-radius-radius0)',
  'radius/radius25': 'var(--mlb-2-1-0-radius-radius25)',
  'radius/radius50': 'var(--mlb-2-1-0-radius-radius50)',
  'radius/radius100': 'var(--mlb-2-1-0-radius-radius100)',
  'radius/radius150': 'var(--mlb-2-1-0-radius-radius150)',
  'radius/radius300': 'var(--mlb-2-1-0-radius-radius300)',
  'radius/radiusMax': 'var(--mlb-2-1-0-radius-radius-max)',
  'radius/radiusBase': 'var(--mlb-2-1-0-radius-radius-base)',
  'space/space0': 'var(--mlb-2-1-0-space-space0)',
  'space/space25': 'var(--mlb-2-1-0-space-space25)',
  'space/space50': 'var(--mlb-2-1-0-space-space50)',
  'space/space75': 'var(--mlb-2-1-0-space-space75)',
  'space/space100': 'var(--mlb-2-1-0-space-space100)',
  'space/space150': 'var(--mlb-2-1-0-space-space150)',
  'space/space200': 'var(--mlb-2-1-0-space-space200)',
  'space/space300': 'var(--mlb-2-1-0-space-space300)',
  'space/space400': 'var(--mlb-2-1-0-space-space400)',
  'space/space500': 'var(--mlb-2-1-0-space-space500)',
  'space/space600': 'var(--mlb-2-1-0-space-space600)',
  'space/space700': 'var(--mlb-2-1-0-space-space700)',
  'space/space800': 'var(--mlb-2-1-0-space-space800)',
  'space/space900': 'var(--mlb-2-1-0-space-space900)',
  'space/space1000': 'var(--mlb-2-1-0-space-space1000)',
  'space/base': 'var(--mlb-2-1-0-space-base)',
  'opacity/opacity5': 'var(--mlb-2-1-0-opacity-opacity5)',
  'opacity/opacity10': 'var(--mlb-2-1-0-opacity-opacity10)',
  'opacity/opacity20': 'var(--mlb-2-1-0-opacity-opacity20)',
  'opacity/opacity40': 'var(--mlb-2-1-0-opacity-opacity40)',
  'opacity/opacity70': 'var(--mlb-2-1-0-opacity-opacity70)',
  'blur/overlay': 'var(--mlb-2-1-0-blur-overlay)',
  'font-size/100': 'var(--mlb-2-1-0-font-size-100)',
  'font-size/200': 'var(--mlb-2-1-0-font-size-200)',
  'font-size/300': 'var(--mlb-2-1-0-font-size-300)',
  'font-size/400': 'var(--mlb-2-1-0-font-size-400)',
  'font-size/500': 'var(--mlb-2-1-0-font-size-500)',
  'font-size/600': 'var(--mlb-2-1-0-font-size-600)',
  'font-size/700': 'var(--mlb-2-1-0-font-size-700)',
  'font-size/800': 'var(--mlb-2-1-0-font-size-800)',
  'font-size/900': 'var(--mlb-2-1-0-font-size-900)',
  'font-size/1000': 'var(--mlb-2-1-0-font-size-1000)',
  'font-size/1100': 'var(--mlb-2-1-0-font-size-1100)',
  'font-size/1200': 'var(--mlb-2-1-0-font-size-1200)',
  'font-weight/400': 'var(--mlb-2-1-0-font-weight-400)',
  'font-weight/500': 'var(--mlb-2-1-0-font-weight-500)',
  'font-weight/600': 'var(--mlb-2-1-0-font-weight-600)',
  'font-weight/700': 'var(--mlb-2-1-0-font-weight-700)',
  'font-weight/800': 'var(--mlb-2-1-0-font-weight-800)',
  'line-height/reset': 'var(--mlb-2-1-0-line-height-reset)',
  'line-height/headline': 'var(--mlb-2-1-0-line-height-headline)',
  'line-height/paragraph': 'var(--mlb-2-1-0-line-height-paragraph)',
  'letter-spacing/default': 'var(--mlb-2-1-0-letter-spacing-default)',
  'letter-spacing/exta-small': 'var(--mlb-2-1-0-letter-spacing-exta-small)',
  'letter-spacing/small': 'var(--mlb-2-1-0-letter-spacing-small)',
  'letter-spacing/medium': 'var(--mlb-2-1-0-letter-spacing-medium)',
  'text-case/default': 'var(--mlb-2-1-0-text-case-default)',
  'text-case/uppercase': 'var(--mlb-2-1-0-text-case-uppercase)',
  'text-case/capitalize': 'var(--mlb-2-1-0-text-case-capitalize)',
  'paragraph-spacing/none': 'var(--mlb-2-1-0-paragraph-spacing-none)',
  'paragraph-spacing/default': 'var(--mlb-2-1-0-paragraph-spacing-default)',
  'paragraph-indent/none': 'var(--mlb-2-1-0-paragraph-indent-none)',
  'text-decoration/none': 'var(--mlb-2-1-0-text-decoration-none)',
  'font-family/proximanova': 'var(--mlb-2-1-0-font-family-proximanova)',
};
